/* ==========================================================================
   Sri Anu Jewellers — "Website Revamp Changes" review (Aug 2026)
   Loaded last from snippets/saj-head.liquid. Additive only: nothing here
   rewrites an earlier fix file, and every routine no-ops if the change it
   makes is already present (so pushing the Liquid later cannot double-apply).
   Point numbers refer to bugs/Website Revamp Changes.docx
   ========================================================================== */
(function () {
  'use strict';
  if (window.__sajFix6) return;
  window.__sajFix6 = 1;

  /* ------------------------------------------------------------------
     48 · The "BIS 916 Hallmarked" banner in the mobile drawer pointed at
     /collections/all, so it opened the whole catalogue. BIS 916 is a gold
     hallmark, so it must land on the gold collection only.
     ------------------------------------------------------------------ */
  var GOLD_URL = '/collections/gold';
  function goldHallmarkLink() {
    document.querySelectorAll('.dr2-trust').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      // Only redirect the catch-all targets; never override a hand-set link.
      if (href === '' || href === '/collections' || href === '/collections/all') {
        a.setAttribute('href', GOLD_URL);
      }
    });
  }

  /* ------------------------------------------------------------------
     1 · The mobile drawer (the hamburger menu) kept the Sri Anu gold menu on
     every Menaxi collection page. saj-fixes.js already lifts the silver nav
     off /pages/menaxi for the DESKTOP row, but it looks for the drawer at
     `.saj-header .dr2-nav` and the drawer markup lives outside .saj-header —
     so the drawer half never ran. Same trick, correct selector, own cache.
     No-ops the moment the drawer already renders the silver menu, so pushing
     the Liquid-level fix later simply switches this off.
     ------------------------------------------------------------------ */
  var MX_SRC = '/pages/menaxi';
  var DR_KEY = 'sajMxDrawer';
  var GOLD_ONLY = /Customization|Diamonds|Gold Scheme/i;

  function drawerNav() { return document.querySelector('.saj-drawer .dr2-nav'); }

  function applyDrawer(html) {
    var dr = drawerNav();
    if (!dr || !html) return;
    dr.innerHTML = html;
    // The server-rendered silver drawer carries both the hard-coded "Home" row
    // and the silver menu's own one. saj-fix4.js collapses them on its next
    // pass; do it here too so the drawer is right the first time it opens.
    var homes = [].slice.call(dr.children).filter(function (a) {
      return a.tagName === 'A' && /^home$/i.test((a.textContent || '').trim());
    });
    if (homes.length > 1) {
      homes[0].setAttribute('href', MX_SRC);
      homes.slice(1).forEach(function (a) { a.remove(); });
    }
  }

  function swapMenaxiDrawer() {
    if (!document.documentElement.classList.contains('saj-menaxi-page')) return;
    if (location.pathname.replace(/\/+$/, '') === MX_SRC) return; // the source page
    var dr = drawerNav();
    if (!dr || !GOLD_ONLY.test(dr.textContent)) return;           // already silver

    var cached = null;
    try { cached = sessionStorage.getItem(DR_KEY); } catch (e) {}
    if (cached) { applyDrawer(cached); return; }

    fetch(MX_SRC, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('menaxi drawer fetch failed'); return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('.saj-drawer .dr2-nav');
        if (!src) return;
        try { sessionStorage.setItem(DR_KEY, src.innerHTML); } catch (e) {}
        applyDrawer(src.innerHTML);
      })
      .catch(function () { /* leave the gold drawer rather than an empty one */ });
  }

  /* ------------------------------------------------------------------
     46 · "Shop by Gender" spacing. The section is a bare
     <section class="saj-container pad"> so there is nothing to target from
     CSS alone on browsers without :has(). Stamp a class on it instead.
     ------------------------------------------------------------------ */
  function stampGender() {
    document.querySelectorAll('.saj-scope .gender').forEach(function (g) {
      var s = g.closest('section');
      if (s && !s.classList.contains('saj-genfix')) s.classList.add('saj-genfix');
    });
  }

  /* ------------------------------------------------------------------
     49 · Searching "peacock haram" listed peacock EARRINGS as well, because
     Shopify ORs the words and searches the whole product record. Plain
     `peacock AND haram` does not fix it either — "Twin Peacock Drop Temple
     Gold Earring" says "pair with a long haram" in its description, so it
     honestly matches both words. Only the TITLE says what a piece actually
     is, so a multi-word query becomes `title:peacock AND title:haram`
     (53 store-wide / 10 in gold, all real peacock harams — earrings gone).

     Guards:
       · queries that already use an operator, a quote or a field filter are
         left exactly as typed;
       · single words stay broad — only multi-word queries are narrowed;
       · common filler words are dropped first, so "gold ring for my wife"
         does not demand "for" and "my";
       · if the strict query ends up with no results at all we fall back to
         the original loose query, marked so we never loop.
     ------------------------------------------------------------------ */
  var FILLER = ['a', 'an', 'and', 'for', 'from', 'in', 'my', 'of', 'on', 'or',
                'the', 'to', 'with', 'your'];
  var OPERATORS = /["'()*]|\b(AND|OR|NOT)\b|\w+:/;

  /* saj-fix3.js already appends a Gold/Diamond (or silver) tag clause to every
     search, and its listeners run before ours. Split that machinery off, work
     on the shopper's own words, then put it back exactly as it was. */
  var SCOPE_RE = /\s+AND\s+(?:\(tag:Gold OR tag:Diamond\)|NOT tag:Gold AND NOT tag:Diamond)\s*$/i;

  function splitScope(q) {
    q = String(q == null ? '' : q);
    var m = SCOPE_RE.exec(q);
    return m ? [q.slice(0, m.index), q.slice(m.index)] : [q, ''];
  }

  function andify(q) {
    if (!q || OPERATORS.test(q)) return null;
    var words = q.trim().split(/\s+/).filter(Boolean);
    if (words.length < 2) return null;
    var kept = words.filter(function (w) {
      return FILLER.indexOf(w.toLowerCase()) === -1;
    });
    if (kept.length < 2) return null;
    return kept.map(function (w) { return 'title:' + w; }).join(' AND ');
  }

  function strictify(q) {
    var parts = splitScope(q);
    var core = andify(parts[0]);
    return core === null ? null : core + parts[1];
  }

  function searchForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var strict = strictify(input.value);
      if (strict) input.value = strict;
    }, true);
  }

  /* The header's predictive dropdown ends with a "See all results" link built
     from what the shopper typed, so it needs the same treatment. The curated
     chips (popular searches, keyword chips carrying data-q) are left alone —
     they are hand-written phrases, and demanding every word of them would
     strand shoppers on an empty page. */
  function searchLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/search"]');
      if (!a || a.hasAttribute('data-q') || a.closest('.srch-chips')) return;
      var u;
      try { u = new URL(a.href, location.origin); } catch (err) { return; }
      var q = u.searchParams.get('q');
      if (!q) return;
      var strict = strictify(q);
      if (!strict || strict === q) return;
      u.searchParams.set('q', strict);
      a.setAttribute('href', u.pathname + u.search);
    }, true);
  }

  /* Show the words the shopper typed, not the operator form we sent Shopify.
     saj-fix3.js repaints the same heading at 900ms and 2600ms, so this runs on
     the same cadence rather than fighting it. */
  var bailedOut = false;

  /* "title:peacock AND title:haram" -> "peacock haram" */
  function readable(q) {
    return String(q || '').replace(/\btitle:/g, '').split(' AND ').join(' ').trim();
  }

  function tidySearchDisplay() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var params = new URLSearchParams(location.search);
    var parts = splitScope(params.get('q') || '');
    if (!/\btitle:/.test(parts[0])) return;
    var plain = readable(parts[0]);

    document.querySelectorAll('.srch-hero h1 em').forEach(function (em) {
      var t = em.textContent || '';
      if (/\btitle:/.test(t)) em.textContent = readable(t);
    });
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      var bare = splitScope(i.value || '')[0];
      if (/\btitle:/.test(bare) || bare !== i.value) i.value = readable(bare);
    });
    if (/\btitle:/.test(document.title)) document.title = readable(document.title);

    // Nothing matched every word — go back to the loose query rather than
    // showing the shopper an empty page. `sajq=1` stops a second rewrite.
    if (!bailedOut && params.get('sajq') !== '1' && document.querySelector('.srch-empty')) {
      bailedOut = true;
      params.set('q', plain + parts[1]);
      params.set('sajq', '1');
      location.replace(location.pathname + '?' + params.toString());
    }
  }

  function boot() {
    goldHallmarkLink();
    stampGender();
    swapMenaxiDrawer();
    tidySearchDisplay();
  }

  searchForms();
  searchLinks();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // The drawer and some sections are re-rendered by the theme editor.
  document.addEventListener('shopify:section:load', function () {
    goldHallmarkLink();
    stampGender();
  });
  // The header group re-renders in the theme editor; re-check the drawer once.
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.querySelector && e.target.querySelector('.dr2-nav')) {
      swapMenaxiDrawer();
    }
  });
  // saj-fixes.js can add .saj-menaxi-page after us; nothing above depends on
  // it, but re-run the cheap DOM stamps once the rest of the fix chain settles.
  window.addEventListener('load', function () {
    goldHallmarkLink();
    stampGender();
    swapMenaxiDrawer();
    tidySearchDisplay();
  });
  // saj-fix3.js repaints the search heading on this cadence; follow it.
  tidySearchDisplay();
  setTimeout(tidySearchDisplay, 950);
  setTimeout(tidySearchDisplay, 2700);
})();
